import React from 'react';
import { Table } from '@benzinga/table';
import { YearlyPriceData } from './types';
import styles from './pricePrediction.module.scss';

interface PricePredictionTableProps {
  predictionData: { [year: number]: YearlyPriceData };
}

const PricePredColumnDef = [
  {
    field: 'year',
    headerName: 'Year',
    valueFormatter: ({ data }) => {
      return data.year || '—';
    },
  },
  {
    field: 'max',
    headerName: 'Bullish Prediction',
    valueFormatter: ({ data }) => {
      return data.max || '—';
    },
  },
  {
    field: 'avg',
    headerName: 'Average Prediction',
    valueFormatter: ({ data }) => {
      return data.avg || '—';
    },
  },
  {
    field: 'min',
    headerName: 'Bearish Prediction',
    valueFormatter: ({ data }) => {
      return data.min || '—';
    },
  },
];

export const PricePredictionTable: React.FC<PricePredictionTableProps> = ({ predictionData }) => {
  return (
    <div className={styles['price-pred-table-wrap']}>
      <Table
        className={styles['benzinga-core-table-wrapper']}
        columnsDef={PricePredColumnDef}
        rowData={Object.values(predictionData)}
      />
    </div>
  );
};
